import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_MULTIPLE_VERTICAL_SHARE_ASSETS = defineFcm('psf_multiple_vertical_share_assets')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share instagram story modal',
		description:
			'Multiple vertical share assets: kill-switch + experiment binding for the share-asset picker inside the Instagram story modal on the promote_or_share share slide-up, letting supporters choose which vertical share visual they post. Locale targeting is managed via the FCM admin panel.',
		template: {
			enabled: false,
			experimentName: 'psf_multiple_vertical_share_assets_experiment',
		},
	});
